import React, { useContext, useState, useEffect, useRef } from "react";
import { Form, Input } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Button from '@mui/material/Button';


function AddTeammatesEmails(props) {
  const addRef = useRef(null);

  const handlePaste = (e, add, fields) => {
    e.preventDefault();
    const existingFields = props.form.getFieldsValue();
    const existingFieldsArray = existingFields["colleague_emails"];
    const pastedData = e.clipboardData.getData('text');
    const pastedDataArray = pastedData.split(/[\t\n]+/).filter(item => item.trim() !== '');
    const newFieldsArray = pastedDataArray.concat(existingFieldsArray).filter((item) => item)
    const newFormFields = {};
    newFormFields["colleague_emails"] = newFieldsArray
    props.form.setFieldsValue(newFormFields)    
  };

  useEffect(() => {
    if (addRef.current) {
      addRef.current();
    }
  }, []);
  
  
  return (
    <Form.List
      name="colleague_emails"
      rules={[
        {
          validator: async (_, names) => {
            if (props.minimumEmailsRequired > 0 && (!names || names.length < props.minimumEmailsRequired)) {
              if (props.minimumEmailsRequired === 1) {
                return Promise.reject(
                  new Error("At least 1 email required")
                );
              } else {
                return Promise.reject(
                  new Error(`At least ${props.minimumEmailsRequired} emails required`)
                );
              }
            }
          },
        },
      ]}
    >
      {(fields, { add, remove }, { errors }) => {
        addRef.current = () => {
          if (!fields.length) {
            add();
          }
        };
        return (
        <>
          {fields.map((field, index) => (
            <Form.Item
              required={false}
              key={field.key}
            >
              <Form.Item
                {...field}
                validateTrigger={["onChange", "onBlur"]}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Please input teammate's email or delete this field.",
                  },
                ]}
                noStyle
              >
                <Input
                  placeholder="example@example.com"
                  addonAfter={fields.length >= props.minimumEmailsRequired ? (
                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => remove(field.name)}
                    />
                  ) : <></>}
                  onPaste={(e) => handlePaste(e, add, fields)}
                />
              </Form.Item>

            </Form.Item>
          ))
          }
          <Form.Item>
            <Button
              disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary"
              sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
              onClick={() => add()}
              style={{ width: "100%" }}
            >
              Invite Teammates
            </Button>
            <Form.ErrorList errors={errors} />
          </Form.Item>
        </>
      )}}
    </Form.List >
  );

}

export default AddTeammatesEmails;